import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { gaWrapper } from 'helpers/analytics';
import Image from 'components/Image';
import Link from '../../../components/Link/Link';
import s from './Faq.scss';

class Faq extends React.Component {
  constructor(props) {
    super(props);
    this.state = { accordianOpen: 0 };
  }
  toggleAccordian = index => {
    const { data: { type, items_ga, gaCategory } = {} } = this.props;
    if (type !== 'accordian') return;
    if (index === this.state.accordianOpen) {
      this.setState({ accordianOpen: '' });
    } else {
      this.setState({ accordianOpen: index });
    }
    const gaData = typeof items_ga === 'string' ? items_ga.split('|') : [];
    const gaCat = gaData[0] || gaCategory || '';
    const gaAction = gaData[1] || '';
    const gaLabel = gaData[2] || '';
    gaWrapper('send', 'event', gaCat, gaAction, gaLabel);
  };
  render() {
    const { accordianOpen } = this.state;
    const {
      data: {
        scrollga,
        des: des = '',
        hl,
        hashtag,
        hashtagurl,
        moretext,
        morelink,
        moretext_ga,
        items = [],
        type,
        gaCategory,
        lineToShow,
      } = {},
      className,
    } = this.props;

    const scrollGAAttr = {
      ...(typeof scrollga === 'string' &&
        scrollga && { 'data-scrollga': scrollga }),
    };

    const wrapperclass = classNames({
      [className]: !!className,
      [`${s.accordian}`]: type === 'accordian',
      [`${s.numberedList}`]: type !== 'accordian',
      [`${s.clickablenumberedList}`]: type === 'clickable_numbered_list',
    });

    const clampClass = classNames({
      [s.clamp_4]: parseInt(lineToShow, 10) === 4,
    });

    return (
      <div className={wrapperclass} {...scrollGAAttr}>
        <div className="contentwrapper">
          <div className={s.sectionHead}>
            <h2>
              {hl}
              <small>
                {des !== '' && <span>{des}</span>}
                <a href={hashtagurl}> {hashtag}</a>
                {type === 'accordian' &&
                  !this.props.hideSource && (
                    <span className={s.source}>
                      Source:
                      <Image
                        src="https://static.toiimg.com/photo/74615061.cms"
                        alt="logo"
                        lazyload
                        offsetVertical={300}
                      />
                    </span>
                  )}
              </small>
            </h2>
          </div>
          <div
            className={
              type === 'accordian' ? s.accordianItems : s.numberedItems
            }
          >
            {items.map((item, index) => (
              <div className={s.list} key={`faq_${type}_${index}`}>
                {type === 'clickable_numbered_list' ? (
                  <Link
                    to={item.wu}
                    className={`${s.accordianHead}`}
                    target={item.ext === 'true' ? '_blank' : ''}
                    data-ga={gaCategory ? `${gaCategory}|${item.hl}|` : ''}
                  >
                    {item.hl}
                  </Link>
                ) : (
                  <div
                    className={`${s.accordianHead} ${index === accordianOpen &&
                      s.active}`}
                    onClick={() => {
                      this.toggleAccordian(index);
                    }}
                  >
                    {item.hl}
                  </div>
                )}
                {item.des &&
                  accordianOpen === index && (
                    <div
                      className={`${s.accordianContent} ${clampClass}`}
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: item.des,
                      }}
                    />
                  )}
              </div>
            ))}
          </div>
        </div>
        {moretext &&
          morelink && (
            <Link
              className={s.btn1}
              to={morelink}
              data-ga={`${moretext_ga}${morelink}`}
            >
              <span>{moretext}</span>
            </Link>
          )}
      </div>
    );
  }
}

Faq.propTypes = {
  data: PropTypes.shape({}),
  hideSource: PropTypes.bool,
  className: PropTypes.string,
};
Faq.defaultProps = {
  data: {},
  hideSource: false,
  className: '',
};
export default Faq;
